let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("jyIv1")).then(() => parcelRequire('jN0Pk'));